import paySystems from "../../../assets/image/pay-systems.png";
import cls from "./GreyBlock.module.scss";

const GreyBlock = () => {
  return (
    <div className={cls.block}>
      <p>
        Безопасное соединение:
      </p>
      <img src={paySystems} alt="pay-system" />
    </div>
  );
};

export default GreyBlock;
